import { AnswerProps } from "../Answer/Answer";

export interface OptionsProps {
    children?: React.ReactElement<AnswerProps>,
    pathId: number
}

export function Options(props: OptionsProps) {
    return <>{props.children}</>
}